export default __webpack_public_path__ + "static/media/rtg-4.8b9ce16e.svg";